


import React from 'react';
import { Grid, Box, Paper, Card, CardMedia, Typography } from '@mui/material';

import { useState } from "react";
import Collapse from "@mui/material/Collapse";
import CardHeader from "@mui/material/CardHeader";
import Container from "@mui/material/Container";
import CardContent from "@mui/material/CardContent";

import Add from
    "@mui/icons-material/Add";
import Remove from
    "@mui/icons-material/Remove";

import IconButton from "@mui/material/IconButton";


import { PAGE_CONSTANT_STYLES } from '../page-constants.jsx'
const RESULT_ITEM_COLOR = PAGE_CONSTANT_STYLES.result_item_color
const RESULT_ITEM_BACKGROUND_COLOR = PAGE_CONSTANT_STYLES.result_item_background_color
const RESULT_ITEM_TEXT_COLOR = PAGE_CONSTANT_STYLES.result_item_text_color

const DETAILS_BACKGROUND_COLOR = PAGE_CONSTANT_STYLES.details_background_color
const DETAILS_TEXT_COLOR = PAGE_CONSTANT_STYLES.details_text_color
// import FoodItem from "./FoodItem"

import ScoreBarComponent from './ScoreBarComponent'

// FONT
import '../../../fonts/font.css'



// optional data to add: 
// vintage (year), 
// bin (location in restaurant - for servers only), 
// vineyard (who makes it)
// rating score - in json files as "rated_by" and "numerical_rating"


// do we want subcategories? - some wines are currently inn multiple categories
//       e.g. sparkling and white, or multiple sub e.g. 'marquis champagne' and 'sommolier featured'



const StyledAddIcon = () => (
    <div style={{ 
        width: '100%', display: 'flex', justifyContent: 'center', 
        padding: '0rem', margin: '0rem', }}>
        <Add
            sx={{
                mx: 2, width: '2rem', height: '2rem', 
                color: DETAILS_TEXT_COLOR, //'#034488', 
                padding: '0rem', margin: '0rem',
            }}
        >
        </Add>
    </div>
);
const StyledRemoveIcon = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Remove
            sx={{
                mx: 2, width: '2rem', height: '2rem', 
                color: DETAILS_TEXT_COLOR, // '#034488', 
                padding: '0rem', margin: '0rem',
            }}
        >
        </Remove>
    </div>
);




const CategoryHeading = (props) => {

    const [open2, setOpen2] = useState(false);

    // Extract data from props
    // const { data } = props;
    // const { item } = props;
    // const { index } = props;

    const item = "props";
    const index = 1;
    const { data } = props
    const data_description = data.description
    // console.log("data_description ", data_description)


    let scoreObject = {

        light_bold_percent: (data.body_light_full / 5) * 100,
        smooth_tannic_percent: (data.tannin_low_high / 5) * 100,
        dry_sweet_percent: (data.dry_sweet / 5) * 100,
        soft_acidic_percent: (data.acid_low_high / 5) * 100,

    }

    let labelObject = {

        light_bold_percent: "LIGHT / BOLD",
        smooth_tannic_percent: "SMOOTH / TANNIC",
        dry_sweet_percent: "DRY / SWEET",
        soft_acidic_percent: "SOFT / ACIDIC",

    }

    // console.log('scoreObject ', scoreObject)
    let passScoreObject = {}
    let passedScoreArray = []

    for (const key in scoreObject) {
        const value = scoreObject[key];
        // Do something with the key and value
       //  console.log(key, value);

        if (value > 0) {
            passScoreObject[key] = value
            let insertObject = {
                label: labelObject[key],
                value: value,
            }
            // passScoreArray.push(labelObject[key])
            // passScoreArray.push(value)

            passedScoreArray.push(insertObject)

        }
        if (value == 0) {
            passScoreObject[key] = value
            let insertObject = {
                label: labelObject[key],
                value: value + 10,
            }
            // passScoreArray.push(labelObject[key])
            // passScoreArray.push(value)

            passedScoreArray.push(insertObject)

        }

    }

    // console.log('passScoreObject ', passScoreObject)
    // console.log('passedScoreArray ', passedScoreArray)







    // let light_bold_percent = (data.body_light_full / 5) * 100
    // let smooth_tannic_percent = (data.tannin_low_high / 5) * 100
    // let dry_sweet_percent = (data.dry_sweet / 5) * 100
    // let soft_acidic_percent = (data.acid_low_high / 5) * 100

    // let scoreVariableNameArray = [
    //     'light_bold_percent',
    //     'smooth_tannic_percent',
    //     'dry_sweet_percent',
    //     'soft_acidic_percent',
    // ]

    // let scorePercentObject = {
    //     body_light_full: light_bold_percent.toString() + '%',
    //     tannin_low_high: smooth_tannic_percent.toString() + '%',
    //     dry_sweet: dry_sweet_percent.toString() + '%',
    //     acid_low_high: soft_acidic_percent.toString() + '%',
    // }

    // console.log('scorePercentObject ', scorePercentObject)
    // scoreVariableNameArray.map((item, index) => (
    //     console.log(item)
    // ))


    // const scores = {

    // }

    ///// console.log("CategoryHeading item ", index, item)

    return (

        <div
            style={{

                marginTop: '1rem',

            }}
        >

            {/* <style>

                {`




.fade {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  
  .visible {
    opacity: 1;
  }
  
  .hidden {
    opacity: 0;
  }






                `}

            </style> */}


            <Card sx={{

                minWidth: 300,
                //border: "6px solid black", //"4px solid rgba(211,211,211,0.6)",

                backgroundColor: DETAILS_BACKGROUND_COLOR, //'#8dbbe6', // RESULT_ITEM_BACKGROUND_COLOR, //RESULT_ITEM_COLOR, 
                // '#011552' //'#edece8'
                // 74acdf   ccdde8  8dbbe6  609cd4


                color: DETAILS_TEXT_COLOR, //RESULT_ITEM_COLOR, //RESULT_ITEM_TEXT_COLOR, 
                //'white'

                //backgroundColor: 'gray',
                borderRadius: '0px',
                opacity: '100%',
                margin: '1rem',
                marginTop: '1rem',
                padding: '0rem',
                // borderWidth: '1rem',
                borderColor: 'black',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                boxShadow: '2px 2px 5px rgba(03, 44, 88 0.5)'

            }}>

                <CardHeader

                    onClick={() => setOpen2(!open2)}
                    aria-label="expand"
                    size="medium"



                    titleTypographyProps={{ fontFamily: 'imported-font-result-text',
                    fontSize: "1.3rem", fontWeight: 'bold', textAlign: 'left', }}
                    title={"Details"}

                    action={

                        <IconButton
                            onClick={() => setOpen2(!open2)}
                            aria-label="expand"
                            size="small"
                        ///// backgroundColor= "rgba(211,211,211,0.4)"
                        >

                            {open2 ? <StyledRemoveIcon />
                                : <StyledAddIcon />}

                        </IconButton>
                    }
                >

                </CardHeader>
                <div style={{
                    padding: '0rem', margin: '0rem', // backgroundColor: '#8dbbf6',
                    ///// backgroundColor: "rgba(211,211,211,0.4)"   '#8dbbf6',
                }}>


                    <Collapse in={open2}  timeout={0}
                    // timeout='0' // timeout='auto'  
                        unmountOnExit
                        
                        style={{
                            padding: '0rem', margin: '0rem', border: '0rem' //, backgroundColor: '#aadff6',
                        }}
                        
                        >
                        <CardContent 
                                                style={{
                                                    padding: '0rem', margin: '0rem', border: '0rem', /// backgroundColor: '#aadff6',
                                                }}
                        >
                            <Container 
                            
                            

                            sx={{
                                height: 'auto',
                                lineHeight: 0,
                                width: '100%',
                                padding: '0rem',
                                margin: '0rem',

                                ////backgroundColor: 'yellow',

                            }}>



                                {/* {open2 && (
                                    <> */}




                                {/* {item.map((foodItem) => ( */}






                                <div
                                    style={{
                                        paddingTop: '0rem',
                                        paddingLeft: '1rem',
                                        paddingRight: '2rem',
                                     //   borderWidth: '10px',
                                     //   backgroundColor: 'black'
                                    }}
                                >
                                    <ScoreBarComponent scoreObject={passScoreObject} scoreArray={passedScoreArray} ></ScoreBarComponent>
                                </div>








                                <div 
                                                                    style={{
                                                                        padding: '1rem',
                                                                        paddingTop: '0rem',
                                                                        //borderWidth: '10px',
                                                                        //backgroundColor: 'black'
                                                                    }}
                                >
                                    {/* <div  className={`fade ${open2 ? 'visible' : 'hidden'}`} key={foodItem.dish_name}> */}


                                    {/* <Typography align={'justify'} style={{fontWeight: 'bold', }}>

                                        DESCRIPTION

                                    </Typography> */}

                                    <Typography align='center' 
                                    sx={{ 
                                        fontFamily: 'imported-font-result-text', 
                                        fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem' }}
                                    >DESCRIPTION
                                    </Typography>


                                    <Typography 
                                    sx={{ 
                                        // fontFamily: 'imported-font-result-text', 
                                    fontSize: '1.2rem', marginBottom: '1rem' }}
                                    align={'justify'}>

                                        {data_description}

                                    </Typography>
                                    {/* <FoodItem foodItem={foodItem} open={open2}  /> */}
                                </div>

                                {/* 
 In 1900, when Georges de Latour's wife, Fernande, first laid eyes on the land that would become their original Rutherford vineyard, she named it "beau lieu," or "beautiful place." Shortly thereafter, de Latour sold his thriving cream of tartar business, bought the four-acre ranch and founded Beaulieu Vineyard with the vision of making Napa Valley wines that would rival those of his native France.De Latour quickly made a name for himself by importing Phylloxera-resistant rootstock from Europe to the recently-ravaged fledgling California wine industry. He also began selling wine to the Catholic Church, establishing a strong relationship that would allow Beaulieu Vineyard to become the only Napa Valley winery to remain in business during Prohibition.In fact, during Prohibition the winery increased its business. After the repeal in 1933, de Latour began searching for someone who could contribute European winemaking expertise. In 1938, he traveled to France and returned with André Tchelistcheff, famed viticulturist and enologist who instituted the philosophy of continuous innovation in vineyard and winery to which we remain dedicated today. Tchelistcheff introduced cold fermentation for white wines, malolactic fermentation for reds and aging red wines in small, French oak barrels. He also tasted the de Latour family's private wine-what they called "Private Reserve"-from the 1936 vintage. This Cabernet Sauvignon-based wine was so distinctive that Tchelistcheff insisted it be bottled and sold as the winery's flagship offering. The result was the inaugural release of Georges de Latour Private Reserve Cabernet Sauvignon, a wine that was destined to become Napa Valley's first "cult" Cabernet.Today we continue to turn to innovative practices to craft wines in our bold, classic style. We have become a leader in clonal research, and our BV Clone Reserve Cabernet Sauvignon wines are highly acclaimed. Most recently we completed a new state-of-the-art winery within one of our original buildings. The Georges de Latour Private Reserve Winery utilizes the latest technology in combination with time-honored traditions for the production of this exceptional, wine-the longtime benchmark of Rutherford Cabernet.#1 wine for 2022
                                    */}

                                {/* ))} */}


                                {/* </>
                                )} */}

                                {/* {!open2 && (
                                    <>
                                        {item.map((foodItem) => (
                                            <div key={foodItem.dish_name} style={{height: '2rem'}}>
                                                
                                            </div>
                                        ))}
                                    </>
                                )} */}





                            </Container>
                        </CardContent>
                    </Collapse>


                </div>
            </Card>



        </div >

    );
};

export default CategoryHeading;





//  <h1 style={{ color: 'white' }}  >item</h1>

/*



.fade {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  
  .visible {
    opacity: 1;
  }
  
  .hidden {
    opacity: 0;
  }




  .fade {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0s linear 0.3s;
  }
  
  .visible {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
  }
  
  .hidden {
    opacity: 0;
    visibility: hidden;
    transition-delay: 0s;
  }



                                {item.map((foodItem) => (
                                    <div key={foodItem.dish_name}>
                                        <FoodItem foodItem={foodItem} open={open2} ></FoodItem>
                                    </div>

                                ))}











        <h1>{foodItem.dish_name}</h1>

        <h1 style={{ color: 'white' }}  >{item[0].category_name}</h1>

        <h1 style={{ color: 'white' }}  >{item[0].category_name}</h1>


        <div>
            <h1 style={{ color: 'white' }}  >{item[0].category_name}</h1>
        </div >


                                {displayItems.map((item) => (
                                    <MenuDisplay key={item.id} item={item}></MenuDisplay>
                                ))}


*/
